import ProductCard from "@/app/(site)/_components/Organisms/Cards/ProductCards/ProductCard"
import { type ProductData } from "@/lib/content-service/types/ContentServiceProduct"
import { clsx } from "@/src/utils/clsx"

export type ProductGroupItem = { key: string; items: ProductData[] }

export function renderProductCard({
    productGroup,
    index,
    isAboveTheFold,
    className,
    params,
    listHierarchy,
    _key
}: {
    productGroup: ProductGroupItem
    index: number
    isAboveTheFold: boolean
    className?: string
    params: { locale: string; categories: string[] }
    listHierarchy: string
    _key: string
}) {
    return (
        <div
            className={clsx("product-card-article isolate", className)}
            key={`${_key}-${index}`}
            role="listitem"
        >
            <ProductCard
                product={productGroup.items[0]}
                isAboveTheFold={isAboveTheFold}
                params={params}
                mediaRatio="0.7"
                imageSizes="(max-width: 767px) 160px, (max-width: 1023px) 480px, 25vw"
                variationsDisplay="thumbnails"
                showSalePercentageBadge
                related="relatedVariants"
                listName="plp"
                listId={listHierarchy || "plp"}
                listType="plp"
                listHierarchy={listHierarchy}
                index={index}
            />
        </div>
    )
}
